import { CommonModule, NgFor } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ProductsService } from '../../services/products.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { FileUploadService } from '../../services/file-upload.service';
import { CbdokProduct } from '../models/cbdok-product.model';

import Quagga from '@ericblade/quagga2';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-products-list',
  standalone: true,
  imports: [
    NgFor,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule
    //NgIf
  ],
  templateUrl: './products-list.component.html',
  styleUrl: './products-list.component.css',
})

export class ProductsListComponent implements AfterViewInit, OnInit {

  productsCount?: string;
  product?: CbdokProduct;
  productExists: {exists: boolean, message: string} = {exists: false, message: ''};
  barcodeResult: string | null = null;

  eanCode: FormControl = new FormControl('');
  nameInput: FormControl = new FormControl('');

  nameExistMessage: string = '';
  productsList?: CbdokProduct[];

  ngAfterViewInit() {
  }

  constructor(
    private productsService: ProductsService,
    private router: Router,
    private notificationService: NotificationService,
  ) {

  }

  imgInputChange(event: any) {
    console.log("wywołano funkcje z wczytaniem zdjęcia");
    
    const file: File = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {
      Quagga.decodeSingle({
        src: reader.result as string,
        numOfWorkers: 0,
        inputStream: {
          size: 800
        },
        decoder: {
          readers: [
            'ean_reader'
          ]
        }
      }, result => {
        if (result?.codeResult) {
          // console.log('Kod:', result.codeResult.code);
          this.eanCode.setValue(result.codeResult.code);
          this.checkProductByEan(this.eanCode.value)
          this.notificationService.pushNotification("Wczytano kod ean","info",3000)
        } else {
          this.notificationService.pushNotification("Nie udało się wczytać kodu","error",5000)
        }
      });
    };

    reader.readAsDataURL(file);

      // this.fileUpladService.fileUpload(formData)
      //   .subscribe({
      //     next: (response: any) => {
      //       console.error("File upload success", response)
      //       alert("Successfully imported: \n \
      //     Total records: " + response.totalRecords + " \n \
      //     Added records: " + response.successRecords + " \n \
      //     Not valid records: " + response.failureRecords)

      //       this.fetchProducts()
      //     },
      //     error: error => {
      //       console.error("File upload error", error)
      //       alert("Error")
      //     }
      //   })

    }

  ngOnInit(): void {
    this.fetchProducts()
  }

  fetchProducts(): void {
    this.productsService.getProductsCount()
      .subscribe({
        next: (response: any) => {
          this.productsCount = response.message
        },
        error: error => {
          console.log("fetchProducts error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }

  checkProductByEan(product: string | number) {
    this.productsService.checkProductByEan(product)
      .subscribe({
        next: (res: any) => {
          this.product = res.product;
          this.productExists = {exists: res.exists, message: res.message};
          console.log("response check product: ",res, "product:", this.product, "productExists:",this.productExists);
        },
        error: err => {
          console.log("Check product error", err);
          this.productExists = err.error;
          if (err.status === 401) {
            this.router.navigate(['/']);
          }
        }
      })
  }

  checkProductByName(name: string) {
    this.nameExistMessage = '';
    this.productsService.checkProductByName(name)
      .subscribe({
        next: (res: any) => {
          this.productsList = res.products;
          if(this.productsList) {
            this.nameExistMessage = name
          }
          // console.log("wszyukanie po nazwie: ",res, "produkt", this.productsList);
        },
        error: err => {
          console.error(err);
          this.nameExistMessage = name;
        }
      })
  }

  blockNumbers(event: KeyboardEvent) {
  const charCode = event.charCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}
}



// import { Component } from '@angular/core';
// import Quagga from '@ericblade/quagga2';

// @Component({
//   selector: 'app-barcode-reader',
//   templateUrl: './barcode-reader.component.html'
// })
// export class BarcodeReaderComponent {

//   barcodeResult: string | null = null;

//   onFileSelected(event: any) {
//     const file: File = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();

//     reader.onload = () => {
//       Quagga.decodeSingle({
//         src: reader.result as string,
//         numOfWorkers: 0, // ważne w Angularze
//         inputStream: {
//           size: 800
//         },
//         decoder: {
//           readers: [
//             'ean_reader',
//             'ean_8_reader',
//             'code_128_reader',
//             'code_39_reader'
//           ]
//         }
//       }, result => {
//         if (result?.codeResult) {
//           this.barcodeResult = result.codeResult.code;
//           console.log('Kod:', result.codeResult.code);
//         } else {
//           this.barcodeResult = 'Nie wykryto kodu';
//         }
//       });
//     };

//     reader.readAsDataURL(file);
//   }
// }